
const Interface = () => {
    return <div>hello</div>
}
export default Interface;